import { render, staticRenderFns } from "./UpsertProgram.vue?vue&type=template&id=5d1d3c0f"
import script from "./UpsertProgram.vue?vue&type=script&lang=js"
export * from "./UpsertProgram.vue?vue&type=script&lang=js"
import style0 from "./UpsertProgram.vue?vue&type=style&index=0&id=5d1d3c0f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports